/* 🤖 this file was generated by svg-to-ts */
export const DfIconQuestionMarkCircle16: {
  name: 'question-mark-circle-16';
  data: string;
} = {
  name: 'question-mark-circle-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-3c.286 0 .519-.087.7-.26s.281-.407.3-.697c0-.29-.09-.53-.271-.724a1.015 1.015 0 0 0-.7-.319H8c-.286 0-.519.092-.7.275s-.281.42-.3.71c0 .29.09.532.271.725.181.193.415.29.7.29zm1-4c.021-2.033 2-1.757 2-3.505C11 4.01 9.744 3 8 3S5 4.006 5 6h2c0-1.327.707-1.484 1-1.484s1.021.039 1.021 1.073C9.021 6.701 7 6.893 7 9a1 1 0 0 0 1 1c.54 0 1-.446 1-1z" fill-rule="evenodd"/></svg>`
};
